//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enterpriseUserJoinApi } from '@/api/user';
export default {
  name: 'DialogForm',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    rolesConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isRequest: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      option: {
        form: {
          labelWidth: '75px'
        },
        submitBtn: false,
        global: {
          frame: {
            props: {
              closeBtn: false,
              okBtn: false,
              onLoad: function onLoad(e) {
                e.fApi = _this.$refs.fc.$f;
              }
            }
          }
        }
      },
      // 表单配置
      rules: []
    };
  },
  watch: {
    rolesConfig: {
      handler: function handler(nVal, oVal) {
        this.rules = this.rolesConfig;
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      localStorage.removeItem('invitationStorage');
      this.dialogFormVisible = false;
    },
    open: function open() {
      this.dialogFormVisible = true;
    },
    goNow: function goNow() {
      this.dialogVisible = false;
      this.$router.push({
        name: 'resume',
        path: '/'
      });
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      enterpriseUserJoinApi({
        invitation: this.formData.invitation
      }).then(function (res) {
        _this2.handleClose();
        localStorage.removeItem('enterprise');
        localStorage.setItem('enterprise', JSON.stringify({
          entid: _this2.formData.entId
        }));
        localStorage.removeItem('invitationStorage');
        if (res.data.perfect == 1) {
          _this2.dialogVisible = true;
        }
      }).catch(function (error) {
        localStorage.removeItem('invitationStorage');
        _this2.handleClose();
      });
    }
  }
};